import { isNumber } from 'lodash';
import { useI18n } from 'vue-i18n';

export enum FieldTypeEnum {
    Text = 'Text',
    Number = 'Number',
    Datetime = 'Datetime',
    Boolean = 'Boolean',
    SelectList = 'SelectList',
    MultiSelectList = 'MultiSelectList',
    Date = 'Date',
}
export enum AutomationStatuses {
    Active = 1,
    NotActive = 2,
    ShowAll = 3,
}
export enum AutomationSortBy {
    LastEdited = 1,
    LastCreated = 2,
    FirstCreated = 3,
    ShowAll = 4,
}
export enum LandingPagesSortBy {
    RecentlyOpened = 1,
    MostViewed = 2,
    Date = 3,
    Name = 4,
}
export enum EmailsSortBy {
    Name = 1,
    CreateDate = 2,
    UpdateDate = 3,
    RecentSending = 4,
}
export enum ContactActionTypeEnum {
    Page = 100,
    Email = 110,
    SMS = 120,
    Automation = 130,
}

export enum BatchStatus {
    Created = 'Created',
    Scheduled = 'Scheduled',
    InProgress = 'InProgress',
    Finished = 'Finished',
    Failed = 'Failed',
    InvalidRecipient = 'InvalidRecipient',
}

// FilterBuilder Enums
export enum ContactFilterFieldEnum {
    Email = 'Email',
    Mobile = 'Mobile',
    FirstName = 'FirstName',
    LastName = 'LastName',
    Birthday = 'Birthday',
    Gender = 'Gender',
    Address = 'Address',
    City = 'City',
    Text1 = 'Text1',
    Text2 = 'Text2',
    Text3 = 'Text3',
    Text4 = 'Text4',
    Text5 = 'Text5',
    Text6 = 'Text6',
    Text7 = 'Text7',
    Text8 = 'Text8',
    Text9 = 'Text9',
    Text10 = 'Text10',
    Text11 = 'Text11',
    Text12 = 'Text12',
    Text13 = 'Text13',
    Text14 = 'Text14',
    Text15 = 'Text15',
    Text16 = 'Text16',
    Text17 = 'Text17',
    Text18 = 'Text18',
    Text19 = 'Text19',
    Text20 = 'Text20',
    Number1 = 'Number1',
    Number2 = 'Number2',
    Number3 = 'Number3',
    Number4 = 'Number4',
    Number5 = 'Number5',
    Datetime1 = 'Datetime1',
    Datetime2 = 'Datetime2',
    Datetime3 = 'Datetime3',
    Datetime4 = 'Datetime4',
    Datetime5 = 'Datetime5',
    CreatedAt = 'CreatedAt',
    CheckBox1 = 'CheckBox1',
    CheckBox2 = 'CheckBox2',
    CheckBox3 = 'CheckBox3',
    CheckBox4 = 'CheckBox4',
    CheckBox5 = 'CheckBox5',
    UnsubscribedEmail = 'UnsubscribedEmail',
    UnsubscribedMobile = 'UnsubscribedMobile',
    Groups = 'Groups',
    Tags = 'Tags',
}

export enum ContactFilterTypeEnum {
    Text = 'Text',
    Number = 'Number',
    Datetime = 'Datetime',
    Boolean = 'Boolean',
    Action = 'Action',
    SelectList = 'SelectList',
    MultiSelectList = 'MultiSelectList',
}

export enum ContactFilterOperationEnum {
    IsNull = 'IsNull',
    IsNotNull = 'IsNotNull',
    Is = 'Is',
    IsNot = 'IsNot',
    Contains = 'Contains',
    ContainsNot = 'ContainsNot',
    StartWith = 'StartWith',
    InRange = 'InRange', // for Date fields
    IsBefore = 'IsBefore', // for Date fields
    IsAfter = 'IsAfter', // for Date fields
    Relative = 'Relative', // for Date fields
    // IsDay = 12,  // for Date fields   - ToDo

    And = 'And', // for MultiSelectList
    Or = 'Or', // for MultiSelectList

    ActionInGroup = 'ActionInGroup',
    ActionNotInGroup = 'ActionNotInGroup',

    ActionClickLPLink = 'ActionClickLPLink',
    ActionNotClickLPLink = 'ActionNotClickLPLink',
    ActionClickEmailLink = 'ActionClickEmailLink',
    ActionNotClickEmailLink = 'ActionNotClickEmailLink',

    ActionOpenLP = 'ActionOpenLP',
    ActionNotOpenLP = 'ActionNotOpenLP',
    ActionOpenEmail = 'ActionOpenEmail',
    ActionNotOpenEmail = 'ActionNotOpenEmail',
    ActionSentEmail = 'ActionSentEmail',
    ActionNotSentEmail = 'ActionNotSentEmail',

    ActionSubmitForm = 'ActionSubmitForm',
    ActionNotSubmitForm = 'ActionNotSubmitForm',

    ActionAutomationStarted = 'ActionAutomationStarted',
    ActionAutomationNotStarted = 'ActionAutomationNotStarted',
    ActionAutomationEnded = 'ActionAutomationEnded',
    ActionAutomationNotEnded = 'ActionAutomationNotEnded',
    ActionClickSmsLink = 'ActionClickSmsLink',
    ActionNotClickSmsLink = 'ActionNotClickSmsLink',
}

export enum ContactFilterJoinTypeEnum {
    AND = 'AND',
    OR = 'OR',
}

export enum ContactData_OR_ContactActionEnum {
    ContactData = 'ContactData',
    ContactAction = 'ContactAction',
}

export enum DateTimeRelativeTypeEnum {
    Day = 1,
    Week = 2,
    Month = 3,
    Year = 4,
}

export enum GenderEnum {
    Male = 1,
    Female = 2,
}

export enum ReleativeSignType {
    Before = 1,
    After = 2,
}
export enum DayOfWeekEnum {
    SU = 0,
    MO = 1,
    TU = 2,
    WE = 3,
    TH = 4,
    FR = 5,
    SA = 6,
}
export enum MandatoryFieldsFlag {
    Email = 1,
    Mobile = 2,
}

export enum WebhookParamsType {
    QueryParams = 1,
    JsonBody = 2,
}

export function ToOptions(e: any, prefix = '') {
    return Object.entries(e)
        .filter((x) => typeof x[0] === 'string' && isNumber(x[1]))
        .map((x) => {
            return {
                id: x[1],
                name: useI18n().t(prefix + x[0].toLowerCase()),
            };
        });
}